import { OrderState } from './state';

/**
 * Finds an Order in the state by uuid.
 * @param state
 * @return A lookup function, which accepts a uuid.
 */
export const order = (state: OrderState) => (uuid: string) => {
  return state.orders.find((order) => order.uuid === uuid);
};

/**
 * Determines if a particular Order has status `Draft`.
 * @param state
 * @param getters
 * @return A lookup function, which accepts a uuid.
 */
export const isDraft = (state: OrderState, _getters) => (uuid: string) => {
  // const order = uuid && _getters.order(uuid);
  const order = state.orders.find((order) => order.uuid === uuid); // temp fix; [TODO] use getter

  return (order && order.status === 'Draft') || false;
};

/**
 * Returns a comma-separated list of the eligible payment methods on an order
 */
export const orderEligiblePaymentMethods = (state: OrderState) => (eligiblePaymentMethods: string[]) => {
  return (
    eligiblePaymentMethods
      .map((eligiblePaymentMethod) => {
        const paymentMethod = state.paymentMethods.find((paymentMethod) => paymentMethod.id === eligiblePaymentMethod);

        return paymentMethod?.name || eligiblePaymentMethod;
      })
      .join(', ') || ''
  );
};
